var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticStyle:{"display":"inline","font-weight":"100","text-decoration":"underline","color":"#dddddd","cursor":"pointer"},attrs:{"title":`${_vm.data.name}`}},[_vm._v(_vm._s(_vm.data.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }